import { IncidentItem} from "./IncidentItem";

export default IncidentItem;
